import { useMemo } from 'react';

import { createWorkerInvitesRequest } from '@vyce/core/src/api/invites';

import { useTypedSelector } from 'src/hooks';

// Teams / locations / pay schedules are loaded by the dialog itself when it opens, so the
// module no longer forwards the Redux company data (which could be stale or half-loaded)
export const useUniversalInviteModuleData = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const selectedCompanyId = selectedCompany?.uuid ?? '';

  const contextOptions = useMemo(
    () => ({
      companyId: selectedCompanyId,
      createInvitesRequest: createWorkerInvitesRequest,
    }),
    [selectedCompanyId]
  );

  return {
    contextOptions,
    selectedCompanyId,
  };
};
